import { Reveal } from "../../lib/motion";
import { ArcButton } from "./Brand";

export const CTASection = () => (
  <section className="bg-charcoal text-chalk" data-testid="cta-section">
    <div className="container-x py-24 md:py-36">
      <div className="max-w-4xl">
        <Reveal>
          <p className="overline text-bronze">Start a conversation</p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-8 font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.08]">
            Considering a new chapter for your home?
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-chalk/70 font-light text-lg leading-relaxed">
            Tell us about your property, ambitions and intended timeline. We would be
            pleased to discuss how Arc &amp; Hollow could shape the project with you.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <ArcButton to="/contact" variant="primary" onDark className="mt-12" data-testid="cta-button">
            Start a conversation
          </ArcButton>
        </Reveal>
      </div>
    </div>
  </section>
);
